export default {
  props: {
    title: String,
    desc: String,
    img: String
  }
};